/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

/**
 * Lazy Loading Video (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */


document.addEventListener("DOMContentLoaded", function() {
    var userAgent = window.navigator.userAgent;

    var isIOS = /iPad|iPhone|iPod/i.test(userAgent) && /WebKit/i.test(userAgent);
    var isChrome = /Chrome/i.test(userAgent) && /Safari/i.test(userAgent);

    if (isIOS || isChrome) {
        var listItems = document.querySelectorAll(".part-top-visual.lazyload li");

        listItems.forEach(function(li, index) {
            var videos = li.querySelectorAll("video");
            var delayTime = (index + 1) * 2000; // インデックスに応じて遅延時間を設定します

            videos.forEach(function(video) {
                video.removeAttribute("autoplay");
                video.pause(); // 再生を停止

                setTimeout(function() {
                    video.play(); // 再生を再開
                }, delayTime);
            });
        });
    }
});

